<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   width="24"
   height="24"
   viewBox="0 0 24 24"
   fill="none"
   version="1.1"
   id="svg2"
   sodipodi:docname="opened-bell.svg"
   inkscape:version="1.4 (e7c3feb100, 2024-10-09)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <sodipodi:namedview
     id="namedview2"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:showpageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     inkscape:deskcolor="#d1d1d1"
     inkscape:zoom="29.429111"
     inkscape:cx="12.402685"
     inkscape:cy="12.504625"
     inkscape:window-width="1916"
     inkscape:window-height="1036"
     inkscape:window-x="0"
     inkscape:window-y="0"
     inkscape:window-maximized="0"
     inkscape:current-layer="svg2" />
  <g
     clip-path="url(#clip0_951_11135)"
     id="g2"
     transform="matrix(1.0570193,0,0,1.0639227,2.2012811,1.3901775)">
    <path
       d="m 9.24991,20.2 c -0.49407,0.0164 -0.98377,-0.0974 -1.42,-0.33 -0.41075,-0.2457 -0.75429,-0.5893 -1,-1 C 6.75756,18.7562 6.70898,18.6289 6.68709,18.4958 6.6652,18.3627 6.67045,18.2266 6.70254,18.0956 c 0.03209,-0.131 0.09034,-0.2541 0.17126,-0.362 0.08091,-0.1079 0.18282,-0.1983 0.29958,-0.2658 0.11677,-0.0675 0.24598,-0.1107 0.37987,-0.127 0.13388,-0.0162 0.26967,-0.0053 0.3992,0.0323 0.12953,0.0376 0.25011,0.101 0.35451,0.1864 0.10439,0.0854 0.19044,0.191 0.25295,0.3105 0.07338,0.1235 0.17652,0.2266 0.3,0.3 0.12681,0.0709 0.26969,0.1082 0.415,0.1082 0.14531,0 0.28819,-0.0373 0.415,-0.1082 0.12856,-0.0701 0.23569,-0.1738 0.31,-0.3 0.06529,-0.1146 0.15269,-0.2151 0.25699,-0.2958 0.1044,-0.0807 0.2237,-0.1399 0.351,-0.1743 0.1273,-0.0344 0.2602,-0.0433 0.391,-0.0261 0.1308,0.0172 0.2569,0.0601 0.371,0.1262 0.1138,0.0662 0.2133,0.1541 0.293,0.2589 0.0797,0.1047 0.138,0.2241 0.1714,0.3514 0.0334,0.1272 0.0414,0.2599 0.0235,0.3902 -0.0179,0.1304 -0.0614,0.256 -0.1279,0.3695 -0.244,0.4121 -0.5879,0.756 -1,1 -0.4528,0.246 -0.96552,0.3603 -1.47999,0.33 z"
       fill="currentColor"
       id="path1" />
    <path
       d="M 15.3902,13.62 H 3.11023 C 4.2914,11.392 4.85748,8.88946 4.75023,6.37 4.74911,5.779 4.86519,5.19365 5.09177,4.6478 5.31835,4.10196 5.65091,3.60647 6.07023,3.19 6.20584,3.04845 6.33128,2.92195 6.45814,2.80776 6.95281,2.3625 7.41615,1.83811 7.69504,1.23382 7.91689,0.753114 8.20845,0.291554 8.5,0 6.5,0 5.15472,1.0781 4.2088,2.23908 3.26289,3.40007 2.74757,4.85245 2.75023,6.35 c 0,5.69 -2.299998,7.41 -2.299998,7.42 -0.186666,0.1155 -0.33012,0.2893 -0.4082307,0.4945 -0.0781105,0.2051 -0.0865361,0.4303 -0.0239754,0.6407 0.0625608,0.2105 0.1926311,0.3945 0.3701401,0.5236 C 0.565675,15.558 0.78076,15.6252 1.00023,15.62 H 17.5002 c 0.2104,-0.0029 0.4146,-0.0722 0.5833,-0.1979 0.1688,-0.1256 0.2936,-0.3014 0.3567,-0.5021 0.14,-0.41 -0.15,-1.37 -0.94,-1.35 -0.62,0.03 -1.41,0.05 -2.11,0.05 z"
       fill="currentColor"
       id="path2" />
  </g>
  <defs
     id="defs2">
    <clipPath
       id="clip0_951_11135">
      <rect
         width="18.48"
         height="20.200001"
         fill="#ff0000"
         id="rect2"
         x="0"
         y="0" />
    </clipPath>
  </defs>
</svg>
